
import { useStatus } from '@platyplus/vue-hasura-backend-plus'
import { useToast } from 'primevue/usetoast'
import { computed, defineComponent, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useSideMenu } from '../composables'

export default defineComponent({
  name: 'AppWrapper',
  setup() {
    const toast = useToast()
    const route = useRoute()
    const isAuthRoute = computed(() => !!route.meta.auth)
    watch(
      () => route.path,
      () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;(toast as any).removeAllGroups()
      }
    )

    const status = useStatus()

    return {
      ...useSideMenu(),
      isAuthRoute,
      status
    }
  }
})
